import "./App.css";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import React, { useState, useEffect } from "react";
import Layout from "./containers/Layout";
import PrivateRoute from "./components/PrivateRoute";
import Home from "./pages/Home";
import Login from "./pages/Login";
import SignUp from "./pages/SignUp";
import ResetPassword from "./pages/ResetPassword";
import FAQ from "./pages/FAQ";
import Services from "./pages/Services";
import Service from "./pages/Service";
import GetStarted from "./pages/GetStarted";
import Posts from "./pages/Posts";
import Checkout from "./pages/Checkout";
import TermsOfService from "./pages/TermsOfService";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import Blog from "./pages/Blog";
import BlogPost from "./pages/BlogPost";
import Reviews from "./pages/Reviews";
import Contact from "./pages/Contact";
import Cart from "./pages/Cart";
import Orders from "./pages/Orders";
import Billing from "./pages/Billing";
import Settings from "./pages/Settings";
import Items from "./pages/Items";
import Ticket from "./pages/HelpDesk";
import PreviewUsers from "./pages/PreviewUsers";
import UpdateMenu from "./pages/UpdateMenu";
import CreateArea from "./pages/CreateArea";
import AllServices from "./pages/AllServices";
import AppContext from "./contexts/appContext";
import useCart from "./hooks/useCart";
import useMenu from "./hooks/useMenu";
import AuthProvider from "./services/AuthProvider";
import ServicePage from "./pages/ServicesPage";

function App() {
  const [menu, setMenu] = useState();
  const [cart, setCart] = useState();

  const { mainCart } = useCart(true);
  const { serviceMenu } = useMenu();

  useEffect(() => {
    setCart(mainCart);
    setMenu(serviceMenu);
  }, [mainCart, serviceMenu]);

  return (
    <AuthProvider>
      <AppContext.Provider
        value={{
          cart,
          setCart,
          menu,
          setMenu,
        }}
      >
        <Router>
          <Layout>
            <Routes>
              <Route path="*" element={<Home />} />
              <Route path="/login" element={<Login />} />
              <Route path="/signup" element={<SignUp />} />
              <Route path="/resetPassword" element={<ResetPassword />} />
              <Route path="/faq" element={<FAQ />} />
              <Route
                path="/:serviceSlug/:serviceId/:categoryId/:subCategory/:itemId"
                element={<Service />}
              />
              <Route
                path="/:serviceSlug/:serviceId/:categoryId/:subCategory"
                element={<Service />}
              />
              <Route path="/:serviceSlug/:serviceId/:categoryId" element={<Service />} />
              <Route
                path="/service/:serviceId/:categoryId/:subCategory/:itemId"
                element={<Service />}
              />
              <Route path="/service/:serviceId/:categoryId/:subCategory" element={<Service />} />
              <Route path="/service/:serviceId/:categoryId" element={<Service />} />
              <Route path="/:serviceSlug/:serviceId" element={<Services />} />
              <Route path="/services/:serviceId" element={<Services />} />
              <Route path="/services/" element={<AllServices />} />
              <Route path="/getstarted" element={<GetStarted />} />
              <Route
                path="/getstarted/:serviceSlug/:serviceId/:categoryId/:subCategory/:itemId/:serviceItemId"
                element={<GetStarted />}
              />
              <Route
                path="/getstarted/:serviceId/:categoryId/:subCategory/:itemId/:serviceItemId"
                element={<GetStarted />}
              />
              <Route
                path="/posts/:username/:email/:serviceId/:categoryId/:subCategory/:itemId/:serviceItemId"
                element={<Posts />}
              />
              <Route path="/checkout/:checkoutType" element={<Checkout />} />
              <Route path="/termsOfService" element={<TermsOfService />} />
              <Route path="/privacyPolicy" element={<PrivacyPolicy />} />
              <Route path="/blog" element={<Blog />} />
              <Route path="/blog/view/:id" element={<BlogPost />} />
              <Route path="/blog/add" element={<CreateArea />} />
              <Route path="/testimonials" element={<Reviews />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/cart" element={<Cart />} />
              <Route path="/items" element={<Items />} />

              <Route element={<PrivateRoute />}>
                <Route path="/blog/edit/:id" element={<CreateArea />} />
                <Route path="/orders" element={<Orders />} />
                <Route path="/billing" element={<Billing />} />
                <Route path="/settings" element={<Settings />} />
                <Route path="/helpDesk" element={<Ticket />} />
                <Route path="/previewUsers" element={<PreviewUsers />} />
                <Route path="/updateMenu" element={<UpdateMenu />} />
                <Route path="/servicesPage" element={<ServicePage />} />
              </Route>
            </Routes>
          </Layout>
        </Router>
      </AppContext.Provider>
    </AuthProvider>
  );
}

export default App;
